import React from 'react';
import { Link } from 'react-router-dom';
import { Stack } from '@mui/material';
import Logo from '../assets/icons/dumbbell-icon.png';

const NavbarSecond = () => {
  return (
    <>
      <div id="toTop" />
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#fed136"
          fillOpacity="1"
          d="M0,256L8.9,224C17.8,192,36,128,53,101.3C71.1,75,89,85,107,112C124.4,139,142,181,160,208C177.8,235,196,245,213,229.3C231.1,213,249,171,267,144C284.4,117,302,107,320,101.3C337.8,96,356,96,373,112C391.1,128,409,160,427,192C444.4,224,462,256,480,245.3C497.8,235,516,181,533,144C551.1,107,569,85,587,90.7C604.4,96,622,128,640,144C657.8,160,676,160,693,138.7C711.1,117,729,75,747,85.3C764.4,96,782,160,800,181.3C817.8,203,836,181,853,197.3C871.1,213,889,267,907,250.7C924.4,235,942,149,960,96C977.8,43,996,21,1013,58.7C1031.1,96,1049,192,1067,234.7C1084.4,277,1102,267,1120,224C1137.8,181,1156,107,1173,106.7C1191.1,107,1209,181,1227,202.7C1244.4,224,1262,192,1280,154.7C1297.8,117,1316,75,1333,90.7C1351.1,107,1369,181,1387,224C1404.4,267,1422,277,1431,282.7L1440,288L1440,0L1431.1,0C1422.2,0,1404,0,1387,0C1368.9,0,1351,0,1333,0C1315.6,0,1298,0,1280,0C1262.2,0,1244,0,1227,0C1208.9,0,1191,0,1173,0C1155.6,0,1138,0,1120,0C1102.2,0,1084,0,1067,0C1048.9,0,1031,0,1013,0C995.6,0,978,0,960,0C942.2,0,924,0,907,0C888.9,0,871,0,853,0C835.6,0,818,0,800,0C782.2,0,764,0,747,0C728.9,0,711,0,693,0C675.6,0,658,0,640,0C622.2,0,604,0,587,0C568.9,0,551,0,533,0C515.6,0,498,0,480,0C462.2,0,444,0,427,0C408.9,0,391,0,373,0C355.6,0,338,0,320,0C302.2,0,284,0,267,0C248.9,0,231,0,213,0C195.6,0,178,0,160,0C142.2,0,124,0,107,0C88.9,0,71,0,53,0C35.6,0,18,0,9,0L0,0Z"
        ></path>
      </svg>
      <Stack
        className="navbarSec"
        id="toTop"
        direction="row"
        justifyContent="space-around"
        sx={{
          gap: { sm: '122px', xs: '40px' },
          mt: { md: '-330px', sm: '-310px', xs: '20px' },
          justifyContent: 'none',
        }}
        px="20px"
      >
        <Link to="/">
          <img
            className="logo-up-sec"
            src={Logo}
            alt="Logo"
            style={{
              width: '70px',
              height: '70px',
              margin: '0 20px',
              border: '3px solid #FF2625',
              borderRadius: '50px',
              padding: '10px',
            }}
          />
        </Link>
        <Stack
          className="stack"
          direction="row"
          gap="40px"
          fontSize="24px"
          alignItems="flex-end"
          mb="20px"
        >
          <Link
            className="link"
            to="/"
            style={{
              textDecoration: 'none',
              color: '#FF2625',
              borderBottom: '3px solid #FF2625',
            }}
          >
            Home
          </Link>
          <a
            className="link"
            href="#about"
            style={{ textDecoration: 'none', color: '#FF2625' }}
          >
            About
          </a>
        </Stack>
      </Stack>
    </>
  );
};

export default NavbarSecond;
